package com.narbase.letsgo.web.models

import com.narbase.letsgo.dto.EnumDtoName
enum class PrizeType(dtoName: String? = null) : EnumDtoName {
    exact,
    share
    ;

    override val dtoName = dtoName ?: this.name
}